import axios from "axios";
import { safeGet } from "../../utils/safeStorage";

const baseURL = `${process.env.REACT_APP_DOMAIN_URL}/api`;

// Fresh axios instance — no caching, always current data
const api = () =>
  axios.create({
    baseURL,
    timeout: 15000,
    headers: {
      Authorization: `Bearer ${safeGet("nd-rest-tkn")}`,
      "Content-Type": "application/json",
    },
  });

export const fetchGamification = async () => {
  try {
    const res = await api().get("/me/gamification");
    return res.data;
  } catch {
    return null;
  }
};

export const submitDailyAnswer = async (selectedOption) => {
  try {
    const res = await api().post("/me/daily-question/answer", {
      selected_option: selectedOption,
    });
    return { ok: true, data: res.data };
  } catch (err) {
    return { ok: false, message: err?.response?.data?.message || "Something went wrong." };
  }
};
